import { render, staticRenderFns } from "./ClockWidgetPanel.vue?vue&type=template&id=49ca95f1&scoped=true"
import script from "./ClockWidgetPanel.vue?vue&type=script&lang=js"
export * from "./ClockWidgetPanel.vue?vue&type=script&lang=js"
import style0 from "./ClockWidgetPanel.vue?vue&type=style&index=0&id=49ca95f1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ca95f1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49ca95f1')) {
      api.createRecord('49ca95f1', component.options)
    } else {
      api.reload('49ca95f1', component.options)
    }
    module.hot.accept("./ClockWidgetPanel.vue?vue&type=template&id=49ca95f1&scoped=true", function () {
      api.rerender('49ca95f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/editor/settingPanel/ClockWidgetPanel.vue"
export default component.exports